import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

import { parseListSearch, type ListSearch } from "@/lib/bilty-list-filters";

const BiltyListPage = lazy(() => import("@/pages/bilty.index.page"));

export const Route = createFileRoute("/bilty/")({
  component: BiltyListPage,
  // V53 — month, status, search and page live in the URL.
  validateSearch: (search: Record<string, unknown>): ListSearch => parseListSearch(search),
});
